export interface Intent {
	id: string;
	key: number;
	order: number;
	name: string;
	utterances: Utterance[];
	commonIntentId?: string;
	entityId?: string;
}

export enum IntentType {
	New,
	Existing,
	Common
}

export interface Utterance {
	id: string;
	key: number;
	value: string;
	order: number;
	isPattern: boolean;
}

export interface CommonIntent {
	id: string;
	name: string;
	utterances: CommonIntentUtterance[];
	entityId?: string;
}

export interface CommonIntentUtterance {
	id: string;
	value: string;
	isPattern: boolean;
}
